module.exports = __webpack_public_path__ + "img/img8.04390516.png";